<template>
  <div id="item">

    <div class="page-title">
      <span class="name">{{ $t('external_pos.title') }}</span>
      <button class="save btn btn-primary" @click="save">{{ $t("save") }}</button>
    </div>

    <Panel title="Configuration" v-if="ready" collapsible>
      <div class="column">
        <div class="group">
          <label>POS</label>
          <select v-model="computedSelected">
            <option v-for="pos in poses" :value="pos.value">{{ pos.text }}</option>
          </select>
        </div>

        <PosSettings v-if="isPosIncluded('ishop')" v-model="data.ishop"/>

        <div v-if="isPosIncluded('isfAgentPolling')">
          <div class="group">
            <label>Maximum retry</label>
            <input type="number" v-model="data.isfAgentPolling.maximumRetry">
          </div>
          <div class="group">
            <label>Sales polling interval delay</label>
            <input type="number" v-model="data.isfAgentPolling.salesPollingIntervalDelay">
          </div>
          <div class="group">
            <input id="modifyDateWithTimeZoneOffset" type="checkbox"
                   v-model="data.isfAgentPolling.modifyDateWithTimeZoneOffset">
            <label for="modifyDateWithTimeZoneOffset">Modify date with time zone offset</label>
          </div>
        </div>

        <div v-if="isPosIncluded('screen')">
          <div class="group">
            <label>{{ $t('external_pos.url') }}</label>
            <input type="text" v-model="data.screen.url">
          </div>
          <div class="group">
            <input id="sendToMaitrePos" type="checkbox" v-model="data.screen.sendToMaitrePos">
            <label for="sendToMaitrePos">{{ $t('external_pos.send_to_maitred') }}</label>
          </div>
          <div class="group">
            <input id="sendNotificationCallForUnconfirmedCall" type="checkbox"
                   v-model="data.screen.sendNotificationCallForUnconfirmedCall">
            <label for="sendNotificationCallForUnconfirmedCall">
              {{ $t('external_pos.send_notification_call_for_unconfirmed_orders') }}
            </label>
          </div>
          <div class="group">
            <input id="updateSaleStatusFromExternalPos" type="checkbox"
                   v-model="data.screen.updateSaleStatusFromExternalPos">
            <label for="updateSaleStatusFromExternalPos">{{ $t('external_pos.update_sale_status') }}</label>
          </div>
          <div class="group">
            <input id="onSaleEventConfirmation" type="checkbox" v-model="data.screen.onSaleEventConfirmation">
            <label for="onSaleEventConfirmation">{{ $t('external_pos.no_response') }}</label>
          </div>
        </div>

        <div v-if="isPosIncluded('aki')">
          <div class="group">
            <label>Company Tag</label>
            <input type="text" v-model="data.aki.companyTag">
          </div>
          <div class="group">
            <input id="chk_call_when_unconfirmed" type="checkbox" v-model="data.aki.callWhenUnconfirmed">
            <label for="chk_call_when_unconfirmed">Appels automatisés sur commande non-confirmée</label>
          </div>
        </div>

        <div v-if="isPosIncluded('sap')">
          <div class="group">
            <label>{{ $t('external_pos.url') }}</label>
            <input type="text" v-model="data.sap.url">
          </div>
          <div class="group">
            <label>Restaurant Id</label>
            <input type="text" v-model="data.sap.restaurantId">
          </div>
          <div class="group">
            <label>User</label>
            <input type="text" v-model="data.sap.user">
          </div>
          <div class="group">
            <label>Password</label>
            <input type="text" v-model="data.sap.password">
          </div>
        </div>

        <div v-if="isPosIncluded('veloce')">
          <div class="group">
            <label>Host</label>
            <input type="text" v-model="data.veloce.host">
          </div>
          <div class="group">
            <label>Port</label>
            <input type="text" v-model="data.veloce.port">
          </div>
          <div class="group">
            <label>Local Host (ip)</label>
            <input type="text" v-model="data.veloce.localHost">
          </div>
          <div class="group">
            <label>Local Port (ex: 5001)</label>
            <input type="text" v-model="data.veloce.localPort">
          </div>
          <div class="group">
            <label>Ghost item id (message-type product, replaces a product unknown to Veloce)</label>
            <input type="text" v-model="data.veloce.ghostItemId">
          </div>
          <div class="group">
            <label>X-Veloce-Token</label>
            <input type="text" v-model="data.veloce.veloceToken">
          </div>
          <div class="group">
            <label>delivery Path</label>
            <input type="text" v-model="data.veloce.deliveryPath" placeholder="ModeX LevelY">
          </div>
          <div class="group">
            <label>takeout Path</label>
            <input type="text" v-model="data.veloce.takeoutPath" placeholder="ModeX LevelY">
          </div>
          <div class="group">
            <label>in place Path</label>
            <input type="text" v-model="data.veloce.inPlacePath" placeholder="ModeX LevelY">
          </div>
          <div class="group">
            <label>Uber Path</label>
            <input type="text" v-model="data.veloce.uberPath" placeholder="ModeX LevelY">
          </div>
          <div class="group">
            <label>Default Selector</label>
            <input type="text" v-model="data.veloce.defaultSelector">
          </div>
          <div class="group">
            <label>Takeout Selector</label>
            <input type="text" v-model="data.veloce.takeoutSelector">
          </div>
          <div class="group">
            <label>Delivery Selector</label>
            <input type="text" v-model="data.veloce.deliverySelector">
          </div>
          <div class="group">
            <label>In place selector</label>
            <input type="text" v-model="data.veloce.inPlaceSelector">
          </div>
          <div class="group">
            <label>Kiosk selector</label>
            <input type="text" v-model="data.veloce.kioskSelector">
          </div>
          <div class="group">
            <label>Delivery fees id</label>
            <input type="text" v-model="data.veloce.deliveryFeesId">
          </div>
          <div class="group">
            <label>Service fees id</label>
            <input type="text" v-model="data.veloce.serviceFeesId">
          </div>
          <div class="group">
            <label>Remark item id</label>
            <input type="text" v-model="data.veloce.remarkId">
          </div>
          <div class="group">
            <label>table number remark item id</label>
            <input type="text" v-model="data.veloce.tableNumberRemarkId">
          </div>
          <div class="group">
            <label>Online payment id</label>
            <input type="text" v-model="data.veloce.paymentTypeId">
          </div>
          <div class="group">
            <label>Kiosk payment id (if not configured, will default on online payment id)</label>
            <input type="text" v-model="data.veloce.kioskPaymentTypeId">
          </div>
          <div class="group">
            <label>Discount payment id</label>
            <input type="text" v-model="data.veloce.discountPaymentId">
          </div>
          <div class="group">
            <label>Loyalty payment id</label>
            <input type="text" v-model="data.veloce.loyaltyPaymentId">
          </div>
          <div class="group">
            <label>Selfserve api host</label>
            <input type="text" v-model="data.veloce.selfServeApiHost">
          </div>
          <div class="group">
            <label>Selfserve api port</label>
            <input type="text" v-model="data.veloce.selfServeApiPort">
          </div>
          <div class="group">
            <input id="patRequestViaSocket" type="checkbox" v-model="data.veloce.patRequestViaSocket">
            <label for="patRequestViaSocket">QR Payment request via socket (required)</label>
          </div>
          <div class="group">
            <input id="generateExpectedTimeFromConfig" type="checkbox"
                   v-model="data.veloce.generateExpectedTimeFromConfig">
            <label for="generateExpectedTimeFromConfig">Generate expected time from configuration (expected time =
              created at + config delay)</label>
          </div>
          <div class="group">
            <input id="sendSaleReferenceNumberAsRemark" type="checkbox"
                   v-model="data.veloce.sendSaleReferenceNumberAsRemark">
            <label for="sendSaleReferenceNumberAsRemark">Send sale reference number (id) as remark</label>
          </div>
          <div class="group">
            <input id="notSendingCustomerInfoAsRemark" type="checkbox"
                   v-model="data.veloce.notSendingCustomerInfoAsRemark">
            <label for="notSendingCustomerInfoAsRemark">Don't send customer info as remark</label>
          </div>
        </div>

        <div v-if="isPosIncluded('maitre')">
          <template v-if="!isPosIncluded('sap')">
            <div class="group">
              <label>Url</label>
              <input type="text" v-model="data.maitre.url">
            </div>
            <div class="group">
              <label>Host</label>
              <input type="text" v-model="data.maitre.host">
            </div>
            <div class="group">
              <label>Port</label>
              <input type="text" v-model="data.maitre.port">
            </div>
          </template>
          <div class="group">
            <label>Delivery fees id</label>
            <input type="text" v-model="data.maitre.deliveryFeesId">
          </div>
          <div class="group">
            <label>Default Remark item id</label>
            <input type="text" v-model="data.maitre.remarkId">
          </div>
          <div class="group">
            <label>Comment remark item id</label>
            <input type="text" v-model="data.maitre.commentRemarkId">
          </div>
          <div class="group">
            <label>Tip item id</label>
            <input type="text" v-model="data.maitre.tipRemarkId">
          </div>
          <div class="group">
            <label>Expected time remark id</label>
            <input type="text" v-model="data.maitre.saleHourRemarkId">
          </div>
          <div class="group">
            <label>Payment method remark id</label>
            <input type="text" v-model="data.maitre.paymentMethodRemarkId">
          </div>
          <div class="group">
            <label>Delivery note remark id</label>
            <input type="text" v-model="data.maitre.deliveryNoteRemarkId">
          </div>
          <div class="group">
            <label>Table number remark id</label>
            <input type="text" v-model="data.maitre.tableNumberRemarkId">
          </div>
          <div class="group">
            <label>Ghost item id</label>
            <input type="text" v-model="data.maitre.ghostItemId">
          </div>

          <div class="columns">
            <div class="column">
              <h5>Revenue center</h5>
              <div class="group">
                <label>Default</label>
                <input type="number" v-model="data.maitre.defaultRevenueCenter">
              </div>
              <div class="group" v-for="o of possibleOverwrites">
                <label>{{ o.service }} {{ o.method }}</label>
                <input type="number" v-model="o.center" :disabled="o.center === undefined">
              </div>
            </div>
            <div class="column">
              <h5>Mode</h5>
              <div class="group">
                <label>Default</label>
                <input type="number" v-model="data.maitre.defaultMode">
              </div>
              <div class="group" v-for="o of possibleOverwrites">
                <label>{{ o.service }} {{ o.method }}</label>
                <input type="number" v-model="o.mode" :disabled="o.mode === undefined">
              </div>
            </div>
            <div class="column">
              <h5>POS number</h5>
              <div class="group">
                <label>Default</label>
                <input type="number" v-model="data.maitre.defaultPosNumber">
              </div>
              <div class="group" v-for="o of possibleOverwrites">
                <label>{{ o.service }} {{ o.method }}</label>
                <input type="number" v-model="o.pos" :disabled="o.pos === undefined">
              </div>
            </div>
          </div>
          <div class="group">
            <label>In place order mode (for takeout only)</label>
            <input type="text" v-model="data.maitre.inPlaceOrderFunction">
          </div>
          <div class="group">
            <label>Payment media id</label>
            <input type="text" v-model="data.maitre.paymentTypeId">
          </div>
          <div class="group">
            <label>Kiosk payment media id</label>
            <input type="text" v-model="data.maitre.kioskPaymentTypeId">
          </div>
          <div class="group">
            <label>Discount type id</label>
            <input type="text" v-model="data.maitre.discountPaymentId">
          </div>
          <div class="group">
            <label>Loyalty payment id</label>
            <input type="text" v-model="data.maitre.loyaltyPaymentId">
          </div>
          <div class="group">
            <label>uber Eats payment media id</label>
            <input type="text" v-model="data.maitre.uberEatsPaymentTypeId">
          </div>
          <div class="group">
            <label>uber Eats discount media id</label>
            <input type="text" v-model="data.maitre.uberDiscountPaymentId">
          </div>
          <div class="group">
            <label>KDS: Send sale number with item id</label>
            <input type="text" v-model="data.maitre.kdsSaleNumberItemId">
          </div>
          <div class="group">
            <label>Shared Printer Id</label>
            <input id="sharedPrinterId" type="text" v-model="data.maitre.sharedPrinterId">
          </div>
          <div class="group">
            <label>
              KDS: Add restrictions for sale number item.
              Will send the item if empty or if a minimum of one item is include in one of those categories
            </label>
            <input type="text" v-model="data.maitre.kdsCategoriesForSaleNumberItem">
          </div>
          <div class="group">
            <label>Waiter Number (QR Payment only)</label>
            <input id="waiterNumber" type="text" v-model="data.maitre.waiterNumber">
          </div>
          <div class="group">
            <input id="closeInvoiceOnPayment" type="checkbox" v-model="data.maitre.closingInvoiceOnSale">
            <label for="closeInvoiceOnPayment">{{ $t('external_pos.close_in_maitred') }}</label>
          </div>
          <div class="group">
            <input id="forceCloseInvoice" type="checkbox" v-model="data.maitre.forceCloseInvoice">
            <label for="forceCloseInvoice">Force close invoice (will always send field as true)</label>
          </div>
          <div class="group">
            <input id="notClosingInvoiceOnDelivery" type="checkbox" v-model="data.maitre.notClosingInvoiceOnDelivery">
            <label for="notClosingInvoiceOnDelivery">Don't close invoice on delivery (to use when dispatch is
              activated)</label>
          </div>
          <div class="group">
            <input id="supportingAvtTax" type="checkbox" v-model="data.maitre.supportingAvtTax">
            <label for="supportingAvtTax">Support AVT Tax (Mont-Tremblant)</label>
          </div>
          <div class="group">
            <input id="logRequest" type="checkbox" v-model="data.maitre.logRequest">
            <label for="logRequest">Log request (for debug purposes)</label>
          </div>
          <div class="group">
            <input id="forceDeliveryTimeToOrderedTime" type="checkbox"
                   v-model="data.maitre.forceDeliveryTimeToOrderedTime">
            <label for="forceDeliveryTimeToOrderedTime">Force force delivery time to order time</label>
          </div>
          <div class="group">
            <input id="chk_usingExternalId" type="checkbox" v-model="data.maitre.usingExternalId">
            <label for="chk_usingExternalId">{{ $t('external_pos.use_external_ids') }}</label>
          </div>
          <div class="group">
            <input id="chk_checkIfPosRunning" type="checkbox" v-model="data.maitre.checkIfPosRunning">
            <label for="chk_checkIfPosRunning">{{ $t('external_pos.check_local_checkout') }}</label>
          </div>
          <div class="group">
            <input id="chk_sendCustomerInfoAsComment" type="checkbox" v-model="data.maitre.sendCustomerInfoAsComment">
            <label for="chk_sendCustomerInfoAsComment">{{ $t('external_pos.send_customer_info') }}</label>
          </div>
          <div class="group">
            <input id="md_updateSaleStatusFromExternalPos" type="checkbox"
                   v-model="data.maitre.updateSaleStatusFromExternalPos">
            <label for="md_updateSaleStatusFromExternalPos">{{ $t('external_pos.update_sale_status') }}</label>
          </div>
          <div class="group">
            <input id="chk_sendSpecialRemark" type="checkbox" v-model="data.maitre.sendingSpecialRemark">
            <label for="chk_sendSpecialRemark">Send "ONLINE ORDER" as comment</label>
          </div>
          <div class="group">
            <input id="chk_retryOnFailure" type="checkbox" v-model="data.maitre.retryOnFailure">
            <label for="chk_retryOnFailure">retry on failure</label>
          </div>
          <div class="group">
            <input id="chk_fallBackOnScreenPos" type="checkbox" v-model="data.maitre.fallBackOnScreenPos">
            <label for="chk_fallBackOnScreenPos">Fall back on screen pos if tunnel is down</label>
          </div>
          <div class="group">
            <input id="chk_sendingAllSaleDetailsAsItem" type="checkbox"
                   v-model="data.maitre.sendingAllSaleDetailsAsItem">
            <label for="chk_sendingAllSaleDetailsAsItem">Send all order details as items </label>
          </div>
          <div class="group">
            <input id="chk_sendingTipAmountInMediaPayment" type="checkbox"
                   v-model="data.maitre.sendingTipAmountInMediaPayment">
            <label for="chk_sendingTipAmountInMediaPayment">Send tip amount in media payment</label>
          </div>
          <div class="group">
            <input id="chk_sendingTipAmountAsCharge" type="checkbox" v-model="data.maitre.sendingTipAmountAsCharge">
            <label for="chk_sendingTipAmountAsCharge">Send tip amount as a charge</label>
          </div>
          <div class="group">
            <input id="chk_sendingDeliveryFeesInChargeField" type="checkbox"
                   v-model="data.maitre.sendingDeliveryFeesInChargeField">
            <label for="chk_sendingDeliveryFeesInChargeField">Send delivery fees amount as a charge in the api</label>
          </div>
          <div class="group">
            <input id="chk_force24HourFormat" type="checkbox" v-model="data.maitre.force24HourFormat">
            <label for="chk_force24HourFormat">Force 24 hours format even if company is set to 12 hour format</label>
          </div>
          <div class="group">
            <input id="chk_sendingDiscountIdInItemDetail" type="checkbox"
                   v-model="data.maitre.sendingDiscountIdInItemDetail">
            <label for="chk_sendingDiscountIdInItemDetail">Send discount code in item detail (Required for UK
              Discount)</label>
          </div>
          <div class="group">
            <input id="chk_retryFailedSaleLocally" type="checkbox" v-model="data.maitre.retryFailedSaleLocally">
            <label for="chk_retryFailedSaleLocally">Retry failed sale locally with ISF agent</label>
          </div>

          <div class="group">
            <div>
              <button class="btn btn-primary" @click="mdSync">{{ $t('external_pos.sync_from_xml') }}</button>
            </div>
          </div>
        </div>

        <div v-if="data.selected !== null && data.selected !== 'ishop'">
          <button class="btn btn-primary" @click="checkConnection">Check</button>
        </div>

      </div>
    </Panel>

    <Panel v-if="isPosIncluded('veloce') || isPosIncluded('aki')">
      <h2>{{ $t('external_pos.inventory_sync') }}</h2>
      <input id="saveConfirm" type="checkbox" v-model="saveConfirm">
      <label for="saveConfirm">{{ $t('external_pos.save_price_change') }}</label>
      <br/>
      <button class="btn btn-primary" @click="sync">Sync</button>
      <br/> <br/>
      <table class="report" v-if="syncResult.items">
        <tr>
          <th>{{ $t('external_pos.mode') }}</th>
          <th>{{ $t('external_id') }}</th>
          <th>{{ $t('external_pos.price') }}</th>
          <th>{{ $t('external_pos.description') }}</th>
          <th>{{ $t('external_pos.type') }}</th>
          <th>{{ $t('external_pos.id') }}</th>
          <th>{{ $t('external_pos.external_price') }}</th>
          <th>{{ $t('external_pos.external_description') }}</th>
        </tr>
        <tr v-for="item of syncResult.items">
          <td>{{ item.mode }}</td>
          <td>{{ item.externalId }}</td>
          <td>{{ item.ishopFoodPrice }}</td>
          <td>{{ item.ishopFoodDescription }}</td>
          <td>{{ item.ishopFoodType }}</td>
          <td>{{ item.mdProductId }}</td>
          <td>{{ item.mdPrice }}</td>
          <td>{{ item.mdDescription }}</td>
        </tr>
      </table>

      <br/> <br/>

      <Panel :title="$t('external_pos.changes_to_save')" v-if="syncResult.itemsWithPriceToUpdate">
        <table class="report">
          <tr>
            <th>{{ $t('external_pos.mode') }}</th>
            <th>{{ $t('external_id') }}</th>
            <th>{{ $t('external_pos.description') }}</th>
            <th>{{ $t('external_pos.external_description') }}</th>
            <th>{{ $t('external_pos.price') }}</th>
            <th>{{ $t('external_pos.upcoming_price') }}</th>
            <th>{{ $t('external_pos.type') }}</th>
          </tr>
          <tr v-for="item of syncResult.itemsWithPriceToUpdate">
            <td>{{ item.method }}</td>
            <td>{{ item.externalId }}</td>
            <td>{{ item.ishopName }}</td>
            <td>{{ item.externalName }}</td>
            <td>{{ item.currentPrice }}</td>
            <td>{{ item.upcomingPrice }}</td>
            <td>{{ item.type }}</td>
          </tr>
        </table>
      </Panel>

      <Panel :title="$t('external_pos.items_not_found')" v-if="syncResult.itemsNotFoundInPos">
        <table class="report">
          <tr>
            <th>{{ $t('external_id') }}</th>
            <th>{{ $t('external_pos.description') }}</th>
            <th>{{ $t('external_pos.type') }}</th>
          </tr>
          <tr v-for="item of syncResult.itemsNotFoundInPos">
            <td>{{ item.externalId }}</td>
            <td>{{ $to(item.name) }}</td>
            <td>{{ item.type }}</td>
          </tr>
        </table>
      </Panel>

      <Panel title="Item sans id externe" v-if="syncResult.itemsWithNoExternalId">
        <table class="report">
          <tr>
            <th>{{ $t('external_pos.description') }}</th>
            <th>{{ $t('external_pos.type') }}</th>
          </tr>
          <tr v-for="item of syncResult.itemsWithNoExternalId">
            <td>{{ $to(item.name) }}</td>
            <td>{{ item.type }}</td>
          </tr>
        </table>
      </Panel>


      <Panel title="Logs" v-if="syncResult.logs" collapsible>
        <div id="result">
          <div v-if="Array.isArray(syncResult.logs)">
            <div v-for="(line, i) of syncResult.logs" :key="`log-${i}`">{{ line }}</div>
          </div>
          <div v-else v-html="syncResult.logs"></div>
        </div>
      </Panel>

    </Panel>


  </div>
</template>

<script>
import {mapActions} from 'vuex';
import PosSettings from "@/components/pos/PosSettings";

export default {
  name: "SettingsExternalPos",
  components: {PosSettings},

  data() {
    return {
      syncResult: {
        logs: null,
        items: null,
        itemsWithPriceToUpdate: null,
        itemsNotFoundInPos: null,
        itemsWithNoExternalId: null,
      },
      possibleOverwrites: [
        {service: 'online', method: 'takeout', center: null, mode: null, pos: null},
        {service: 'online', method: 'delivery', center: null, mode: null, pos: null},
        {service: 'online', method: 'inPlace', center: null, mode: null, pos: null},
        {service: 'kiosk', method: 'takeout', center: null, mode: null, pos: null},
        {service: 'kiosk', method: 'delivery', center: null, mode: null, pos: null},
        {service: 'kiosk', method: 'inPlace', center: null, mode: null, pos: null},
        {service: 'uber_eats', method: 'delivery', center: null, mode: null, pos: null}
      ],
      companyId: null,
      branchId: null,
      ready: false,
      saveConfirm: false,
      data: {
        selected: null,
        screen: {
          url: '',
          sendToMaitrePos: false,
          sendNotificationCallForUnconfirmedCall: false,
          updateSaleStatusFromExternalPos: false,
          onSaleEventConfirmation: false
        },
        aki: {
          companyTag: '',
          callWhenUnconfirmed: false
        },
        maitre: {
          url: null,
          host: null,
          deliveryFeesId: null,
          remarkId: null,
          commentRemarkId: null,
          tipRemarkId: null,
          saleHourRemarkId: null,
          paymentMethodRemarkId: null,
          tableNumberRemarkId: null,
          ghostItemId: null,
          paymentTypeId: null,
          uberEatsPaymentTypeId: null,
          uberDiscountPaymentId: null,
          defaultRevenueCenter: null,
          defaultMode: null,
          defaultPosNumber: null,
          overwrites: null,
          inPlaceOrderFunction: null,
          kioskPaymentTypeId: null,
          discountPaymentId: null,
          discountPaymentMediaId: null,
          loyaltyPaymentId: null,
          closingInvoiceOnSale: false,
          forceCloseInvoice: false,
          forceDeliveryTimeToOrderedTime: false,
          usingExternalId: false,
          checkIfPosRunning: false,
          sendCustomerInfoAsComment: false,
          updateSaleStatusFromExternalPos: false,
          kdsSaleNumberItemId: null,
          kdsCategoriesForSaleNumberItem: [],
          logRequest: false,
          sendingSpecialRemark: false,
          retryOnFailure: false,
          fallBackOnScreenPos: false,
          sendingAllSaleDetailsAsItem: false,
          sendingTipAmountInMediaPayment: false,
          sendingTipAmountAsCharge: false,
          sendingDeliveryFeesInChargeField: false,
          notClosingInvoiceOnDelivery: false,
          supportingAvtTax: false,
          sharedPrinterId: null,
          waiterNumber: null,
          force24HourFormat: false,
          sendingDiscountIdInItemDetail: false,
          retryFailedSaleLocally: false,
        },
        veloce: {
          host: '',
          port: '',
          localHost: null,
          localPort: null,
          ghostItemId: null,
          veloceToken: null,
          deliveryFeesId: null,
          serviceFeesId: null,
          remarkId: null,
          tableNumberRemarkId: null,
          paymentTypeId: null,
          kioskPaymentTypeId: null,
          discountPaymentId: null,
          loyaltyPaymentId: null,
          notSendingCustomerInfoAsRemark: false,
          deliveryPath: "Mode1 Level1",
          takeoutPath: "Mode1 Level1",
          inPlacePath: null,
          uberPath: null,
          defaultSelector: null,
          takeoutSelector: null,
          deliverySelector: null,
          inPlaceSelector: null,
          kioskSelector: null,
          selfServeApiHost: null,
          selfServeApiPort: null,
          patRequestViaSocket: true,
          generateExpectedTimeFromConfig: true,
          sendSaleReferenceNumberAsRemark: false
        },
        sap: {
          url: '',
          restaurantId: '',
          user: '',
          password: ''
        },
        isfAgentPolling: {
          pos: 'maitre',
          maximumRetry: 100,
          salesPollingIntervalDelay: 5,
          modifyDateWithTimeZoneOffset: true,
        },
        ishop: {
          usingXPos: false,
          xPosConfig: {}
        }
      }
    }
  },

  computed: {
    poses() {
      return [
        { value: null, text: this.$t('none_m') },
        { value: 'screen', text: 'Reception screen' },
        { value: 'screen+maitre', text: 'Reception screen (with Maitre D)' },
        { value: 'maitre', text: 'Maitre D' },
        { value: 'aki', text: 'Aki' },
        { value: 'veloce', text: 'Veloce' },
        { value: 'sap+maitre', text: 'Sap (Maitre D only)' },
        { value: 'isfAgentPolling+veloce', text: 'ISF Agent Polling with Veloce' },
        { value: 'isfAgentPolling+maitre', text: 'ISF Agent Polling with MaitreD' },
        { value: 'ishop', text: 'Ishop POS' }
      ]
    },
    computedSelected: {
      get() {
        let selected = this.data.selected
        if (selected === 'isfAgentPolling') {
          return `${selected}+${this.data.isfAgentPolling.pos}`
        } else if (selected === 'sap') {
          return `${selected}+maitre`
        } else if (selected === 'screen' && this.data.screen.sendToMaitrePos) {
          return `${selected}+maitre`
        } else {
          return selected;
        }
      },
      set(value) {
        if (value && value.includes('+')) {
          let [selected, pos] = value.split('+')
          this.data.selected = selected;
          if (selected === 'isfAgentPolling') {
            this.data.isfAgentPolling.pos = pos;
          } else if (selected === 'screen' && pos === 'maitre') {
            this.data.screen.sendToMaitrePos = true;
          }
        } else {
          this.data.selected = value;
          if (value === 'screen') {
            this.data.screen.sendToMaitrePos = false;
          }
        }
      }
    }
  },

  watch: {
    possibleOverwrites: {
      deep: true,
      handler: function (overwrites) {
        let tmp = {};
        for (let o of overwrites) {
          let center = parseInt(o.center);
          let mode = parseInt(o.mode);
          let pos = parseInt(o.pos);
          if (!center && !mode && !pos) {
            continue;
          }
          if (!tmp[o.service]) {
            tmp[o.service] = {}
          }
          if (!tmp[o.service][o.method]) {
            tmp[o.service][o.method] = {}
          }
          if (center) {
            tmp[o.service][o.method]['center'] = center
          }
          if (mode) {
            tmp[o.service][o.method]['mode'] = mode
          }
          if (pos) {
            tmp[o.service][o.method]['pos'] = pos
          }
        }
        this.data.maitre.overwrites = tmp;
      }
    }
  },

  mounted() {
    this.companyId = this.$route.query.company;
    this.branchId = this.$route.query.branch;
    this.$store.commit('showSpinner', true);
    Promise
        .all([
          this.getCompanyExternalPos({companyId: this.companyId, branchId: this.branchId})
        ])
        .then(([external_posData]) => {
          if (external_posData) {
            this.data.selected = external_posData.selected[0] || this.data.selected;
            this.data.veloce = external_posData.veloce || this.data.veloce;
            this.data.aki = external_posData.aki || this.data.aki;
            this.data.maitre = external_posData.maitre || this.data.maitre;
            this.data.screen = external_posData.screen || this.data.screen;
            this.data.sap = external_posData.sap || this.data.sap;
            this.data.isfAgentPolling = external_posData.isfAgentPolling || this.data.isfAgentPolling;
            this.data.ishop = external_posData.ishop || this.data.ishop

            let maitreOverwrites = external_posData.maitre ? external_posData.maitre.overwrites : null;
            for (let o of this.possibleOverwrites) {
              if (maitreOverwrites && maitreOverwrites[o.service] && maitreOverwrites[o.service][o.method]) {
                o.center = maitreOverwrites[o.service][o.method]['center'] || null;
                o.mode = maitreOverwrites[o.service][o.method]['mode'] || null;
                o.pos = maitreOverwrites[o.service][o.method]['pos'] || null;
              }
            }

            this.ready = true
          } else {
            toast(this.$t("error.no_server"), "error");
          }
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          this.$store.commit('showSpinner', false);
        })
  },

  methods: {
    ...mapActions(["getCompanyExternalPos", "saveCompanyExternalPos", "checkExternalPosConnection", "syncInventory"]),

    isPosIncluded(pos) {
      return this.computedSelected && this.computedSelected.includes(pos)
    },

    async save() {
      let keepKeys = ['selected'];
      let includedPoses = this.computedSelected;
      if (includedPoses) {
        includedPoses = includedPoses.split('+');

        for (let includedPos of includedPoses) {
          keepKeys.push(includedPos);
        }
      }
      let data = {};
      for (let [k, v] of Object.entries(this.data)) {
        if (keepKeys.includes(k)) {
          data[k] = v
        }
      }
      showSpinner();
      let r = await this.saveCompanyExternalPos({branchId: this.branchId, companyId: this.companyId, data});
      hideSpinner();
      if (r) {
        toast(this.$t("success"), "success");
      } else {
        toast(this.$t("error.no_server"), "error");
      }
    },

    async checkConnection() {
      let posName = this.data.selected;
      if (posName) {
        let posConfig = posName === 'ishop'
            ? {company: this.companyId} /* hack-around */
            : this.data[posName];

        showSpinner();
        let r = await this.checkExternalPosConnection({posName, posConfig});
        hideSpinner();
        if (r) {
          let message = Object.entries(r)
              .filter(([k, _]) => k !== 'trace')
              .map(([k, v]) => `${k} : ${v}`)
              .join('<br>');

          let failed = !r.online;
          toast(message, failed ? 'error' : 'success');
          if (r.trace) {
            console.log(r.trace);
          }
        } else {
          toast(this.$t("error.no_server"), "error");
        }
      }
    },


    async sync() {
      let posName = this.data.selected;
      if (posName) {
        showSpinner();
        let data = {
          save: this.saveConfirm,
          locale: this.$ts.state.locale
        };
        let r = await this.syncInventory({branchId: this.branchId, companyId: this.companyId, posName, data});
        hideSpinner();
        if (r && !r.exception) {
          this.syncResult.logs = r.prices_sync_logs;
          this.syncResult.items = r.report.mdItems;
          this.syncResult.itemsWithPriceToUpdate = r.itemsWithPriceToUpdate;
          this.syncResult.itemsNotFoundInPos = r.itemsNotFoundInPos;
          this.syncResult.itemsWithNoExternalId = r.itemsWithNoExternalId;

          toast(this.$t("success"), "success");
        } else {
          toast(r && r.exception ? r.exception : this.$t("error.no_server"), "error");
        }
      }
    },

    mdSync() {
      this.$router.push({path: '/settings/maitred-sync', query: Object.assign({inventory: null}, this.$route.query)});
    }
  }
}
</script>

<style lang="scss" scoped>
.report {
  width: 100%;

  td, th {
    padding: 4px 4px;
    text-align: left;
  }

  th {
    white-space: nowrap;
    background-color: #ddd;
  }

  tr:nth-child(odd) {
    background-color: #eee;
  }

  tr {
    page-break-inside: avoid;
  }
}
</style>